import { useSignal } from '@preact/signals'

import {
	Button,
	ComingSoonModal,
	HorizontalDivider,
	Input,
	Typography
} from 'components'
import { userInformationState } from 'state'

type Props = {
	openModal: () => void
}

const UpgradeSection = ({ openModal }: Props) => (
	<div class='rounded-md border border-black-800 bg-black-850 p-5'>
		<Typography
			color='text-black-100'
			text='Your Plan'
			variant='h5'
			weight='font-bold'
		/>
		<Typography
			class='mb-5 mt-2'
			color='text-black-200'
			text='You are under the free Plan.'
			variant='text3'
		/>
		<Button onClick={openModal} text='Upgrade' variant='secondary' fullWidth />
	</div>
)

const ProfilePage = () => {
	const isComingSoonModalOpen = useSignal(false)

	const toggleModal = () => {
		isComingSoonModalOpen.value = !isComingSoonModalOpen.value
	}

	return (
		<>
			<div class='flex grid-cols-1 flex-col-reverse gap-10 xl:grid xl:grid-cols-[2fr_1fr]'>
				<div class='flex-1'>
					<Typography color='text-black-100' text='Your Profile' variant='h3' />
					<Typography
						class='mt-2'
						color='text-black-200'
						text='Below is your current profile information.'
						variant='text1'
					/>
					<HorizontalDivider className='my-10' />
					<form class='w-full space-y-7'>
						<Input
							id='username'
							label='Username'
							name='username'
							onInput={() => {}}
							value={userInformationState.peek()!.userHandler}
							disabled
							fullWidth
						/>
						<Input
							id='firstName'
							label='First Name'
							name='firstName'
							onInput={() => {}}
							value={userInformationState.peek()!.firstName}
							disabled
							fullWidth
						/>
						<Input
							id='lastName'
							label='Last Name'
							name='lastName'
							onInput={() => {}}
							value={userInformationState.peek()!.lastName}
							disabled
							fullWidth
						/>
					</form>
				</div>
				<div>
					<UpgradeSection openModal={toggleModal} />
				</div>
			</div>

			<ComingSoonModal
				description='Choose the perfect plan to power your dApp development. From basic features to advanced collaboration tools, our upcoming Plans will make it easy to scale and manage your projects. Stay tuned—more details are on the way!'
				isModalOpen={isComingSoonModalOpen.value}
				onCloseModal={toggleModal}
				title='Plans'
			/>
		</>
	)
}

export { ProfilePage }
